import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { Badge } from '@/components/ui/badge';
import { Info } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function StatusInfoDialog() {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="ghost" size="icon" className="h-5 w-5 ml-1">
          <Info className="h-4 w-4 text-muted-foreground hover:text-primary transition-colors" />
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Status Calculado do Cliente</DialogTitle>
          <DialogDescription>
            O status é calculado automaticamente com base na última transação e no tipo de plano contratado.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="flex items-start gap-3">
            <Badge variant="default" className="mt-1">Ativo</Badge>
            <div>
              <p className="font-semibold">Cliente Ativo</p>
              <p className="text-sm text-muted-foreground">
                Cliente com renovação dentro do prazo esperado conforme o período de cobertura do plano.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <Badge variant="secondary" className="mt-1">Em Risco</Badge>
            <div>
              <p className="font-semibold">Cliente Em Risco</p>
              <p className="text-sm text-muted-foreground">
                Cliente com atraso na renovação, mas ainda dentro da tolerância estabelecida para o tipo de plano.
                <br />
                <span className="text-xs italic mt-1 block">
                  • Plano Mensal: até 30 dias de atraso<br />
                  • Plano Trimestral: até 45 dias de atraso<br />
                  • Plano Anual: até 90 dias de atraso
                </span>
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <Badge variant="destructive" className="mt-1">Churned</Badge>
            <div>
              <p className="font-semibold">Cliente Churned (Perdido)</p>
              <p className="text-sm text-muted-foreground">
                Cliente com atraso na renovação superior à tolerância do plano. Provavelmente cancelou ou não renovou.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <Badge variant="outline" className="mt-1">Sem Transações</Badge>
            <div>
              <p className="font-semibold">Sem Histórico de Transações</p>
              <p className="text-sm text-muted-foreground">
                Cliente cadastrado mas sem nenhum registro de pagamento no sistema.
              </p>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
